import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import Concept from "../views/ConceptView.vue";
import Medical from "../views/MedicalView.vue";
import Case from "../views/CaseView.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "/home",
    component: HomeView,
    hidden: true,
    title: "首页",
  },
  {
    path: "/concept",
    name: "/products",
    component: Concept,
    hidden: true,
    title: "新概念套箱式洁净手术室整体解决方案",
  },
  {
    path: "/medical",
    name: "/products",
    component: Medical,
    hidden: true,
    title: "医疗感染风险监测整体解决方案",
  },
  {
    path: "/home",
    name: "/home",
    component: HomeView,
    hidden: false,
    title: "首页",
  },
  {
    path: "/products",
    name: "/products",
    component: Concept,
    hidden: false,
    title: "产品与方案",
    children: [
      {
        path: "/medical",
        name: "/products",
        component: Concept,
        title: "医疗感染风险监测整体解决方案",
      },
      {
        path: "/concept",
        name: "/products",
        component: Medical,
        title: "新概念套箱式洁净手术室整体解决方案",
      },
    ],
  },
  {
    path: "/case",
    name: "/case",
    component: Case,
    hidden: false,
    title: "成功案例",
  },
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
